import { render, staticRenderFns } from "./resolve.vue?vue&type=template&id=20f17570&scoped=true&"
import script from "./resolve.vue?vue&type=script&lang=js&"
export * from "./resolve.vue?vue&type=script&lang=js&"
import style0 from "./resolve.vue?vue&type=style&index=0&id=20f17570&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f17570",
  null
  
)

export default component.exports